import * as React from 'react'
import { ReactElement } from 'react'
import { useDispatch } from 'react-redux'
import CommandDialog, { Dismiss } from '../Command/CommandDialog'
import TimeForm from '../../Form/Time/TimeForm'
import FormikCommandButtons from '../../Form/FormikCommandButtons'
import useAxios from '../../../hooks/useAxios'
import { getOnSubmitWithCallback } from '../../Form/FormButtons'
import { useLocation } from 'react-router-dom'
import { TimeMutationDto } from '../../../config/registrationConfig'
import { IBackgroundLocationState } from '../../../config/appConfig'
import { TimeAction } from '../../../config/registration/timeConfig'
import { useTranslation } from 'react-i18next'

export default function AddTimeDialog(): ReactElement {
    const axios = useAxios()
    const dispatch = useDispatch()
    const location = useLocation<IBackgroundLocationState<TimeMutationDto>>()
    const { t: translate } = useTranslation()

    return (
        <CommandDialog dialogContentProps={{ title: translate('action.create.time.title') }}>
            {({ onDismiss }: { onDismiss: Dismiss }) => (
                <TimeForm
                    initialValues={location.state?.data}
                    onSubmit={getOnSubmitWithCallback(
                        dispatch,
                        values => ({
                            type: TimeAction.Add,
                            payload: axios.post('/time', values),
                        }),
                        onDismiss,
                    )}
                >
                    <FormikCommandButtons dismiss={onDismiss} />
                </TimeForm>
            )}
        </CommandDialog>
    )
}
